'use client';
import styles from './styles.module.scss';

interface IButtonStyled {
  variant: 'primary' | 'secondary' | 'inverted';
  disabled?: boolean;
  children: React.ReactNode;
  onClick: () => void;
  style?: any;
}

const SylndrButton = ({
  variant,
  disabled = false,
  children,
  onClick = () => {},
  style,
}: IButtonStyled) => {
  return (
    <button
      className={`${styles.button} ${variant ? styles[variant] : ''} ${
        disabled ? styles.disabled : ''
      }`}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {children}
    </button>
  );
};
export default SylndrButton;
